<template>
  <layout-content><document-upload-form /></layout-content>
</template>

<script>
  import DocumentUploadForm from '@core/components/documents/documents-upload-form';
  export default {
    components: { DocumentUploadForm }
  };
</script>
